// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"87":"15ea8e21","432":"3dd06d80","748":"de8ee864"}[chunkId] + ".chunk.css";
};